'use client';

import { c as _c } from "react/compiler-runtime";
import Logo from '@shared/utils/icons/Logo';

// The factiii mark for the funnel splash: a glow pulse, a slow rotating halo, a
// sheen sweep, and a gentle float. CSS port of the mobile reanimated + SVG
// version; the keyframes live in tailwind.config.js.
const AnimatedLogo = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div aria-hidden={true} className="absolute size-40 animate-logo-glow rounded-full" style={{
      background: "radial-gradient(circle, rgba(129,140,248,0.55) 0%, rgba(99,102,241,0.28) 45%, rgba(99,102,241,0) 70%)"
    }} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute left-1/2 top-0 size-16 -translate-x-1/2 rounded-full blur-md" style={{
      background: "radial-gradient(circle, rgba(129,140,248,0.9) 0%, rgba(129,140,248,0) 70%)"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div aria-hidden={true} className="absolute size-36 animate-logo-halo">{t1}<div className="absolute bottom-0 left-1/2 size-16 -translate-x-1/2 rounded-full blur-md" style={{
        background: "radial-gradient(circle, rgba(99,102,241,0.9) 0%, rgba(99,102,241,0) 70%)"
      }} /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Logo height={108} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative flex size-44 items-center justify-center">{t0}{t2}<div className="animate-logo-float"><div className="relative size-[108px] overflow-hidden rounded-[28px]">{t3}<div aria-hidden={true} className="absolute -top-12 h-[200px] w-12 animate-logo-sheen" style={{
            background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.45) 50%, rgba(255,255,255,0) 100%)"
          }} /></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default AnimatedLogo;